<template>
	<CRow>
		<CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}
            </CAlert>
        </CCol>
		<CCol col="12">
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Advertisement</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
                                <CButton
                                    color="primary"
                                    v-on:click="createTableRow"
                                    v-if="checkPermission('advertisement-create')"
                                    style="margin-right: 10px"
                                >
                                    {{ $lang.buttons.general.crud.create }}
                                </CButton>
								<CButtonGroup class="file-export">
									<CButton color="secondary" disabled>
										{{ $lang.buttons.export.title }}
									</CButton>
									<CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf" v-on:click="exports(this, 'pdf', module, 'withdrawalRequest')">
										<i class="fas fa-file-pdf"></i>
									</CButton>
									<VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel" :json-data="json_data" :labels="json_label" :csv-title="json_title">
										<i class="fas fa-file-excel"></i>
									</VueJsonToCsv>
								</CButtonGroup>
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
					<v-server-table :url="module.api.list" :columns="columns" :options="options" :data="data" ref="myTable">
                        <template #users="data">
                            <span v-if="data.row.userType === 'DirectCandidate'">
                                {{ data.row.directCandidate.firstName }} {{ data.row.directCandidate.lastName }}
                            </span>
                            <span v-else>
                                {{ data.row.user.firstName }} {{ data.row.user.lastName }}
                            </span>
                        </template>
                        <template #repeats="data">
                            {{ getRepeatLabel(data.row.repeat) }}
                        </template>
                        <template #status="data">
                            {{ getStatusLabel(data.row.status) }}
                        </template>
                        <template #associationName="data">
                            {{ data.row.advertiseCollegeAlumni.map(item => item.associationName).join(', ') }}
                        </template>
						<template #actions="data">
							<CButton
								color="warning"
								v-c-tooltip="$lang.buttons.general.crud.view"
								v-on:click="viewTableRow(data.row)"
                                v-if="checkPermission('advertisement-view-remove')"
							>
								<i class="fas fa-eye"></i>
							</CButton>
                            <CButton
                                color="success"
                                v-c-tooltip="$lang.buttons.general.crud.edit"
                                v-on:click="editTableRow(data.row.id)"
                                v-if="checkPermission('advertisement-update')"
                            >
                                <i class="fas fa-pencil-alt"></i>
                            </CButton>
                            <CButton
                                color="danger"
                                v-c-tooltip="$lang.buttons.general.crud.delete"
                                v-on:click="deletePopup(data.row.id)"
                                v-if="checkPermission('advertisement-delete')"
                            >
                                <i class="fas fa-trash"></i>
                            </CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import { advertisement } from "/src/store/url.js";
import store from "../../store/store";
import { Mixin } from "/src/mixins/index.js";
import VueJsonToCsv from "vue-json-to-csv";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(ServerTable, {}, false);
Vue.use(VueSweetalert2);
export default {
	name: "Advertisement",
	mixins: [Mixin],
	components: {
		VueJsonToCsv
	},
	data() {
		return {
			self: this,
            json_data: [],
			json_label: {},
			json_title: "",
			messageColor: "success",
			alertMessage: "",
			showAlert: false,
			dismissCountDown: false,
			dismissCountDownS: false,
			activePage: 1,
            module: advertisement,
			columns: [
				 'users','userType', 'associationName', 'startDate', 'endDate', 'repeats', 'status', 'actions'
			],
			data: [],
			options: {
				headings: {
                'users': 'User',
				'userType': 'User Type',
				'associationName': 'Association Name',
				'startDate': 'Start Date',
				'endDate': 'End Date',
				'repeats': 'Repeat',
				'status': 'Status',
				'actions': 'Actions'
				},
				sortable: ['userName'],
				filterable: ['userName']
			}
		};
	},
	mounted() {
        let self = this;
		store.commit('showLoader', false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
	},
    watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
    methods: {
		setAlert(value) {
			this.showAlert = value;
		},
        createTableRow() {
            this.$router.push({name: "Advertisement Create"});
        },
		viewTableRow(item) {
			let self = this;
			self.$v.$reset();
			self.submitType = "Update";
			self.editId = item;
            this.$store.commit('clearSelectedRequest');
            this.$store.commit('setSelectedRequest', item);
			this.$router.push({path: `advertisement/view/${item.id}`});
		},
		rowClicked(item, index) {
			this.$router.push({path: `advertisement/view/${item}`});
		},
        editTableRow(item) {
            this.$router.push({path: `advertisement/edit/${item}`});
            // this.$router.push({path: 'Advertisement Edit', params: {id: item}})
        },
		pageChange(val) {
			this.$router.push({query: {page: val}});
		},
        getRepeatLabel(value) {
            switch (value) {
            case 0: return "Per Day";
            case 1: return "Week";
            case 2: return "Month";
            case 3: return "Year";
            default: return "-";
            }
        },
        getStatusLabel(value) {
            switch (value) {
            case 0: return "Draft";
            case 1: return "Public";
            default: return "-";
            }
        },
        deletePopup(item) {
            this.$swal({
                title: this.$lang.common.delete_swal.are_you,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#e55353",
                confirmButtonText: this.$lang.common.delete_swal.yes_delete,
                cancelButtonText: this.$lang.common.delete_swal.cancel,
            }).then((result) => {
                if (result.value) {
                    let self = this;
                    axios.delete(this.deleteUrlWeb(this.module, item), self).then(function (response) {
                        if (response.status === 200) {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.dismissCountDownS = 10;
                            self.messageColor = "success";
                        } else {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.messageColor = "danger";
                            self.dismissCountDownS = 10;
                        }
                    });
                }
            });
        }
	},
};
</script>

<style>
div .error {
	color: red;
}

.hasError label {
	color: red;
}
</style>